var uniqueId = new Date().getTime();
var localStorage = window.localStorage;

export const generateUniqueId = () => ++uniqueId;

export const isLoggedIn = () => localStorage._userId && localStorage._token;

export const getUserId = () => localStorage._userId ? atob(localStorage._userId) : "";

export const setUserId = userId => localStorage._userId = btoa(userId);

export const getToken = () => localStorage._token;

export const setToken = token => localStorage._token = token;

export const setFastDataStationId = stationId => localStorage.fDataStationId = btoa(stationId);

export const getFastDataStationId = () => localStorage.fDataStationId ? atob(localStorage.fDataStationId) : "";

export const clearTimeOfDate = date => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
}

export const getStationTime = (date, stationTimeOffset) => {
  let graphTimestamp = date.getTime();
  let graphTimeInSeconds = (graphTimestamp / 1000) + date.getTimezoneOffset() * 60;

  var offsets = stationTimeOffset.dstOffset * 1000 + stationTimeOffset.rawOffset * 1000;
  var destinationDate = new Date(graphTimeInSeconds * 1000 + offsets);
  return destinationDate;
}

export const getDaysInMonth = (year, month) => {
  const daysInMonth = new Date(year, month, 0).getDate();
  const days = [];
  for(var i = 0; i < daysInMonth; i++){
    days.push(i + 1);
  }
  return days;
}

export const getPreviousYears = () => {
  let years = [];
  let currentYear = new Date().getFullYear();
  for(var i = 0; i < 20; i ++){
    years.push(currentYear - i);
  }
  return years;
}

export const calculateDateRange = (view, year, month, day) => {
  let start = new Date(year, 0, 1); // Start of the year
  let end = new Date(year, 11, 31); // End of the year

  if (view === 'month') {
    start = new Date(year, month - 1, 1); // Start of the selected month
    end = new Date(year, month, 0); // Last day of the selected month
  } else if (view === 'day') {
    start = new Date(year, month - 1, day); // The selected day
    end = new Date(year, month - 1, day); // The selected day
  }

  // Format dates as YYYY-MM-DD without timezone conversion
  const formatDate = (date) => {
    const z = (n) => (n < 10 ? '0' : '') + n; // Add leading zero if needed
    return `${date.getFullYear()}-${z(date.getMonth() + 1)}-${z(date.getDate())}`;
  };

  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
  };
};

export const scrollTo = (elem, style, unit, from, to, time, prop) => {
  if (!elem) {
      return;
  }
  var start = new Date().getTime(),
      timer = setInterval(function () {
          var step = Math.min(1, (new Date().getTime() - start) / time);
          if (prop) {
              elem[style] = (from + step * (to - from))+unit;
          } else {
              elem.style[style] = (from + step * (to - from))+unit;
          }
          if (step === 1) {
              clearInterval(timer);
          }
      }, 1);
  if (prop) {
        elem[style] = from+unit;
  } else {
        elem.style[style] = from+unit;
  }
}

export const createActionObject = (type, others) => ({ type, ...others });
export const getNoArgDispatcherFunc = type => () => dispatch => dispatch(createActionObject(type));
export const getAjaxFunc = (requestActionType, requestMessage , responseFailedActionType, responseFailedMessage, dispatch) => actionFunc => () => {
  dispatch(
    createActionObject(
      requestActionType,
      { message: requestMessage}
    )
  );

  return actionFunc()
  .catch(error => dispatch(
    createActionObject(
      responseFailedActionType,
      { message: responseFailedMessage }
    )
  ))
}
